var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { timer } from 'rxjs/observable/timer';
var Singlegatewaywait2Component = /** @class */ (function () {
    function Singlegatewaywait2Component(router, Util, Api) {
        this.router = router;
        this.Util = Util;
        this.Api = Api;
        this.ref_id = "";
        this.timeLeft = 3600;
        this.message = "";
    }
    Singlegatewaywait2Component.prototype.ngOnInit = function () {
        var btn = document.querySelector('.btn');
        btn.addEventListener('click', function () {
            console.log("a");
        });
        this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal"));
        this.InvestigateAndAppealCondition(this.PortalUser.contactid);
        this.startTimer();
        this.startTimer2();
    };
    Singlegatewaywait2Component.prototype.InvestigateAndAppealCondition = function (UID) {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs, drosWeb, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thisTs = this;
                        if (!!this.Util.IsNullOrUndefined(UID)) return [3 /*break*/, 2];
                        drosWeb = '';
                        return [4 /*yield*/, this.Api.postCustomApi("SingleGateway", "GetRefID", { UID: UID })];
                    case 1:
                        result = _a.sent();
                        if (!this.Util.IsNullOrUndefined(result) && result.length > 0) {
                            if (!this.Util.IsNullOrUndefined(result[0].authorizationUrl)) {
                                drosWeb = result[0].authorizationUrl;
                                sessionStorage.setItem("referenceId", result[0].referenceId);
                                this.ref_id = result[0].referenceId;
                                window.open(drosWeb, "_blank");
                            }
                            else {
                                this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
                                thisTs.router.navigate(["mainmenu/index"]);
                            }
                        }
                        else {
                            this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
                            thisTs.router.navigate(["mainmenu/index"]);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
                        thisTs.router.navigate(["mainmenu/index"]);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Singlegatewaywait2Component.prototype.startTimer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var source;
            return __generator(this, function (_a) {
                source = timer(1000, 2000);
                this.abc = source.subscribe(function (val) {
                    if (val < 3600) {
                        _this.message = _this.dhms(_this.timeLeft - val);
                    }
                    else {
                        var thisTs = _this;
                        _this.Util.WarningDialog("ท่านไม่ได้ทำรายการในเวลาที่กำหนด กรุณาเข้าระบบใหม่อีกครั้งหลังจากทำการยืนยันตัวตนเสร็จสิ้น");
                        thisTs.router.navigate(["mainmenu/index"]);
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    Singlegatewaywait2Component.prototype.startTimer2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var source2;
            return __generator(this, function (_a) {
                source2 = timer(3000, 6000);
                this.abc2 = source2.subscribe(function (val) {
                    if (_this.ref_id != "") {
                        var para = "refId=" + _this.ref_id;
                        _this.Api.get("crmservice", "GetSingleGatewayLog", para).then(function (ContactRes) {
                            if (ContactRes.dpa_result !== undefined) {
                                if (ContactRes.dpa_result == 'Y') {
                                    var thisTs = _this;
                                    _this.Util.SuccessDialog("ท่านได้ทำการยืนยันตัวตนสำเร็จ");
                                    thisTs.router.navigate(["mainmenu/refundDeposits"]);
                                }
                                else if (ContactRes.dpa_result == 'N') {
                                    var thisTs = _this;
                                    _this.Util.ErrorDialog("ท่านทำการยืนยันตัวตนไม่สำเร็จ กรุณาทำการยืนยันตัวตนอีกครั้ง โดยใช้หมายเลขบัตรประชาชน หรือหมายเลขโทรศัพท์ที่ท่านได้ทำการลงทะเบียนไว้");
                                    thisTs.router.navigate(["mainmenu/refundDeposits"]);
                                }
                            }
                        });
                    }
                    var btn = document.querySelector('.btn');
                    var clickEvent = new Event('click');
                    btn.dispatchEvent(clickEvent);
                });
                return [2 /*return*/];
            });
        });
    };
    Singlegatewaywait2Component.prototype.dhms = function (t) {
        var minutes, seconds;
        minutes = Math.floor(t / 60) % 60;
        t -= minutes * 60;
        seconds = t % 60;
        return [
            minutes + ' นาที',
            seconds + ' วินาที'
        ].join(' ');
    };
    Singlegatewaywait2Component.prototype.ngOnDestroy = function () {
        //prevent memory leak when component destroyed
        this.abc.unsubscribe();
        this.abc2.unsubscribe();
    };
    return Singlegatewaywait2Component;
}());
export { Singlegatewaywait2Component };



// WEBPACK FOOTER //
// ./src/app/singlegatewaywait2/singlegatewaywait2.component.ts.pre-build-optimizer.js